type EscapeHtmlOptions = {
  whiteList?: Array<keyof HTMLElementTagNameMap>
  escapeAll?: boolean
}

const TAG_PATTERN = /<[^>]*>/g

const escapeTag = (tag: string) =>
  tag.replace(/</g, '&lt;').replace(/>/g, '&gt;')

const escapeHtml = (value: string, options?: EscapeHtmlOptions) => {
  if (options?.escapeAll) return value.replace(TAG_PATTERN, escapeTag)

  const whiteList = new Set(
    (options?.whiteList ?? []).map((tag) => tag.toLowerCase()),
  )

  return value.replace(TAG_PATTERN, (tag) => {
    const tagMatch = tag.match(/^<\s*(\/?)\s*([a-zA-Z][\w:-]*)/)

    if (!tagMatch) return escapeTag(tag)

    const [, closingSlash, rawTagName] = tagMatch
    const tagName = rawTagName.toLowerCase()
    const isClosingTag = closingSlash === '/'

    if (!whiteList.has(tagName)) return escapeTag(tag)

    if (isClosingTag) return `</${tagName}>`
    if (tagName === 'br' || /\/\s*>$/.test(tag)) return `<${tagName} />`

    return `<${tagName}>`
  })
}

export default escapeHtml
